import { ProgramTypes } from "../types/programTypes";
import type { ProgramMetricsRequest, ProgramDetailRequest, UserPreferenceValue } from "../types/programTypes";
import { config } from "../../config/config";
import type { PreferenceKey } from "../../config/constants";

export const getProgramOnboardRequest = () => ({
  type: ProgramTypes.GET_PROGRAM_ONBOARD_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/program/onboard`,
        method: "GET",
      },
      commit: { type: ProgramTypes.GET_PROGRAM_ONBOARD_SUCCESS },
      rollback: { type: ProgramTypes.GET_PROGRAM_ONBOARD_FAILURE },
    },
  },
});

export const getProgramMetricsRequest = (payload: ProgramMetricsRequest) => ({
  type: ProgramTypes.GET_PROGRAM_METRICS_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/program/metrics`,
        method: "POST",
        json: payload,
      },
      commit: { type: ProgramTypes.GET_PROGRAM_METRICS_SUCCESS },
      rollback: { type: ProgramTypes.GET_PROGRAM_METRICS_FAILURE },
    },
  },
});

export const getProgramDetailRequest = (payload: ProgramDetailRequest) => ({
  type: ProgramTypes.GET_PROGRAM_DETAIL_REQUEST,
  meta: { cardType: payload.card_type },
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/program/detail`,
        method: "POST",
        json: payload,
      },
      commit: { type: ProgramTypes.GET_PROGRAM_DETAIL_SUCCESS, meta: { cardType: payload.card_type } },
      rollback: { type: ProgramTypes.GET_PROGRAM_DETAIL_FAILURE, meta: { cardType: payload.card_type } },
    },
  },
});

export const getUserPreferenceRequest = (preferenceKey: PreferenceKey) => ({
  type: ProgramTypes.GET_USER_PREFERENCE_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/common/user-preference?preference_key=${encodeURIComponent(preferenceKey)}`,
        method: "GET",
      },
      commit: { type: ProgramTypes.GET_USER_PREFERENCE_SUCCESS },
      rollback: { type: ProgramTypes.GET_USER_PREFERENCE_FAILURE },
    },
  },
});

export const saveUserPreferenceRequest = (preferenceKey: PreferenceKey, preferenceValue: UserPreferenceValue) => ({
  type: ProgramTypes.SAVE_USER_PREFERENCE_REQUEST,
  http: {
    cognito: {
      effect: {
        url: `${(config as any).BASE_URL}/common/user-preference`,
        method: "POST",
        json: {
          preference_key: preferenceKey,
          preference_value: preferenceValue,
        },
      },
      commit: { type: ProgramTypes.SAVE_USER_PREFERENCE_SUCCESS },
      rollback: { type: ProgramTypes.SAVE_USER_PREFERENCE_FAILURE },
    },
  },
});
